<template>
  <span>{{ display }}</span>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'

const props = defineProps({
  value: { type: Number, default: 0 },
  duration: { type: Number, default: 1200 },
  decimals: { type: Number, default: 0 },
})

const current = ref(0)
let frame = null

const display = computed(() =>
  current.value.toLocaleString(undefined, {
    minimumFractionDigits: props.decimals,
    maximumFractionDigits: props.decimals,
  })
)

function animate(from, to) {
  if (frame) cancelAnimationFrame(frame)
  const start = performance.now()
  const step = (now) => {
    const progress = Math.min((now - start) / props.duration, 1)
    const eased = 1 - Math.pow(1 - progress, 3)
    current.value = from + (to - from) * eased
    if (progress < 1) frame = requestAnimationFrame(step)
  }
  frame = requestAnimationFrame(step)
}

onMounted(() => animate(0, Number(props.value) || 0))
watch(() => props.value, (next, prev) => animate(Number(prev) || 0, Number(next) || 0))
onBeforeUnmount(() => { if (frame) cancelAnimationFrame(frame) })
</script>
